import { useState } from "react";
import axios from "axios";

function AddDepartment({onClose}){

const [departmentName,setDepartmentName]=useState("");
const [description,setDescription]=useState("");

const saveDepartment=async(e)=>{

e.preventDefault();

try{

const token=
localStorage.getItem(
"token"
);

const response=
await axios.post(

"https://saleupcall.com/api/Department/add-department.php",

{
department_name:departmentName,
description
},

{
headers:{
Authorization:
`Bearer ${token}`
}
}

);

if(response.data.status){

alert(
"Department Added"
);

setDepartmentName("");
setDescription("");

if(onClose){

onClose();

}

}
else{

alert(
response.data.message
);

}

}
catch(error){

console.log(error);

}

};

return(

<form onSubmit={saveDepartment}>

<div className="row">

<div className="col-md-12 mb-2">

<input
type="text"
className="form-control form-control-sm"
placeholder="Department Name"
value={departmentName}
onChange={(e)=>
setDepartmentName(
e.target.value
)
}
/>

</div>

<div className="col-md-12 mb-2">

<textarea
className="form-control form-control-sm"
rows="3"
placeholder="Description"
value={description}
onChange={(e)=>
setDescription(
e.target.value
)
}
/>

</div>

</div>

<div className="text-end mt-1">

<button
type="submit"
className="btn btn-primary btn-sm"
>

<i className="bi bi-check-lg me-1"></i>

Save Department

</button>

</div>

</form>

);

}

export default AddDepartment;